export const selectStartPageStatus = state => state.views.startPage.status;

export const selectStartPageHeader = state =>
    state.views.startPage.status === 'HAS_DATA'
        ? state.views.startPage.config.header
        : {};
